<svg
  id="knotenAuslastungContainer"
  width="400px"
  height="300px"
  class="associations"
  #knotenAuslastungContainer
></svg>
